export default __webpack_public_path__ + "static/media/2020.f7c23db3.png";